































































import _ from 'lodash';
import { Vue, Component } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import MatrixConfigService from '@/domain/matrix-config/service/matrix-config.service';
import MatrixConfig from '@/domain/matrix-config/entity/matrix-config.entity';
import Quadrant from '@/domain/matrix-config/entity/quadrant.entity';
import AuthorityStore from '@/domain/security/authority.store';
import AuthorityEnum from '@/domain/security/authority.enum';
import QuadrantsPanel from './quadrants-panel.component.vue';
import QuadrantEdit from './quadrant-edit.component.vue';

@Component({
  components: {
    QuadrantsPanel,
    QuadrantEdit,
  },
})
export default class QuadrantSettings extends Vue {
  loading: boolean = true;

  loadingSave: boolean = false;

  matrixConfig: MatrixConfig = new MatrixConfig();

  selectedQuadrantId : string = '';

  quadrantsBackup: Array<Quadrant> = [];

  hasUpdateQuadrantAuthority: boolean = false;

  selectQuadrant(quadrantId: string) {
    const { form }: any = this.$refs;
    if (this.selectedQuadrantId && !form.validate()) {
      VbSnackbarService.showError('Ajuste os campos antes de selecionar outro quadrante.');
      return;
    }
    this.selectedQuadrantId = quadrantId;
  }

  get editingQuadrant(): Quadrant {
    return this.getEditingQuadrant()!;
  }

  inputQuadrantLabel(value: string) {
    const quadrant = this.getEditingQuadrant();
    if (!quadrant) return;
    quadrant.label = value;
  }

  inputQuadrantDescription(value: string) {
    const quadrant = this.getEditingQuadrant();
    if (!quadrant) return;
    quadrant.description = value;
  }

  inputQuadrantColor(value: string) {
    const quadrant = this.getEditingQuadrant();
    if (!quadrant) return;
    quadrant.hexColor = value;
  }

  inputQuadrantTextColor(value: string) {
    const quadrant = this.getEditingQuadrant();
    if (!quadrant) return;
    quadrant.hexTextColor = value;
  }

  private getEditingQuadrant(): Quadrant | undefined {
    return this.matrixConfig.quadrants.find(
      (quadrant: Quadrant) => quadrant.id === this.selectedQuadrantId,
    );
  }

  reloadQuadrant() {
    const quadrantIndex = this.matrixConfig.quadrants.findIndex(
      (it: Quadrant) => it.id === this.selectedQuadrantId,
    );
    if (quadrantIndex === null || quadrantIndex === undefined || quadrantIndex < 0) return;
    const backup = this.quadrantsBackup.find((it: Quadrant) => it.id === this.selectedQuadrantId);
    if (!backup) return;
    this.setBackupQuadrantAndReRender(quadrantIndex, backup);
  }

  setBackupQuadrantAndReRender(quadrantIndex: number, backup: Quadrant) {
    this.$set(
      this.matrixConfig.quadrants,
      quadrantIndex,
      _.cloneDeep(backup),
    );
  }

  closeQuadrant() {
    const { form }: any = this.$refs;
    if (!form.validate()) {
      VbSnackbarService.showError('Ajuste os campos antes de fechar.');
      return;
    }
    this.selectedQuadrantId = '';
  }

  saveMatrixConfig() {
    const { form }: any = this.$refs;
    if (this.selectedQuadrantId && !form.validate()) {
      VbSnackbarService.showError('Ajuste os campos antes de salvar.');
      return;
    }
    this.loadingSave = true;
    MatrixConfigService.updateMatrixConfig(this.matrixConfig)
      .then(() => {
        this.selectedQuadrantId = '';
        this.loadMatrix();
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loadingSave = false });
  }

  private loadMatrix() {
    this.loading = true;
    MatrixConfigService.getMatrixConfig().then((matrixConfig: MatrixConfig) => {
      this.matrixConfig = matrixConfig;
      this.quadrantsBackup = _.cloneDeep(matrixConfig.quadrants);
    }).catch(error => VbSnackbarService.handleHttpError(error))
      .finally(() => { this.loading = false });
  }

  private loadUpdateQuadrantAuthority() {
    AuthorityStore.hasAuthority([AuthorityEnum.UPDATE_QUADRANT_SETTINGS])
      .then((hasUpdateQuadrantAuthority) => {
        this.hasUpdateQuadrantAuthority = hasUpdateQuadrantAuthority;
      });
  }

  created() {
    this.loadMatrix();
    this.loadUpdateQuadrantAuthority();
  }
}
